'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _smoothScrollTo = require('./smoothScrollTo');

var _smoothScrollTo2 = _interopRequireDefault(_smoothScrollTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (node, _ref) {
  var orientation = _ref.orientation,
      direction = _ref.direction,
      pageSize = _ref.pageSize;

  if (!direction) {
    throw new Error('Please provide a scroll direction: 1 or -1!');
  }

  var horiz = orientation == 'horizontal';
  var scrollPosName = horiz ? 'scrollLeft' : 'scrollTop';

  pageSize = pageSize || (horiz ? node.clientWidth - 20 : node.clientHeight - 20);

  var currentValue = node[scrollPosName];
  var newValue = currentValue + direction * pageSize;

  (0, _smoothScrollTo2.default)(node, newValue, {
    orientation: orientation
  });
}; /**
    * Copyright (c) 2015-present, Zippy Technologies
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */